import { Link } from "react-router-dom";

const borderColors = [
    "#15e61c",
    "#4b82ca",
    "#be2c6b",
    "#f55708",
    "#3c0983",
    "#dbf386",
    "#f5d415",
    "#ef9708",
    "#bd09a5",
    "#0be2c9",
    "#de7bd9",
    "#694104",
];
export default function BrandCard({
    brand, index
}) {




    return (

        <Link
            // to={`/brand/${brand.slug}`}
            to={`/products?brand=${brand.id}`}          
            className="home-brand-card"

        >

            <div className="home-brand-card__image" style={{
                "--border-color":
                    brand.borderColor || borderColors[index % borderColors.length],
            }}
            >
                <img
                    src={brand.image}
                    alt={brand.title}
                    loading="lazy"
                />
            </div>

            <div className="home-brand-card__title">
                {brand.title}
            </div>

        </Link>

    );

}